const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        workItemFailures: 'Formulardaten nicht vorhanden, Email fehlt',
        ReportsBtn: 'Berichte',
        InvoicesBtn: 'Rechnungskopien',
    },
    __RELATIVE_SOURCE_FILE__
);
